import React, { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { SPECIES } from "@/lib/constants";
import { PetAvatar } from "@/components/PetAvatar";

const EMPTY = { name: "", species: "dog", breed: "", birthday: "", weight: "", microchip: "", allergies: "", conditions: "", medications_note: "", food: "", quirks: "", vet_name: "", vet_phone: "" };

export function PetForm({ initial, onSubmit, submitLabel = "Save pet", compact = false, saving }) {
  const [f, setF] = useState(EMPTY);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  useEffect(() => { setF({ ...EMPTY, ...(initial || {}) }); setPreview(initial?.photo_url || null); }, [initial]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const pick = (e) => {
    const fl = e.target.files?.[0];
    if (!fl) return;
    setFile(fl);
    setPreview(URL.createObjectURL(fl));
  };
  const field = (k, label, ph, type = "text") => (
    <div><label className="pl-label">{label}</label>
      <input type={type} data-testid={`pet-${k}-input`} className="pl-input" placeholder={ph} value={f[k] || ""} onChange={set(k)} /></div>
  );
  return (
    <form data-testid="pet-form" className="space-y-4" onSubmit={(e) => { e.preventDefault(); onSubmit(f, file); }}>
      <label className="flex items-center gap-4 cursor-pointer" data-testid="pet-photo-picker">
        <PetAvatar url={preview && preview.startsWith("blob:") ? preview : preview} name={f.name || "?"} size={88} ring />
        <span className="pl-btn-ghost"><Camera className="h-4 w-4" />{preview ? "Change photo" : "Add photo"}</span>
        <input type="file" accept="image/*" className="hidden" data-testid="pet-photo-input" onChange={pick} />
      </label>
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">{field("name", "Name *", "e.g. Bella")}</div>
        <div><label className="pl-label">Species</label>
          <select data-testid="pet-species-select" className="pl-input capitalize" value={f.species} onChange={set("species")}>
            {SPECIES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select></div>
        {field("breed", "Breed", "e.g. Beagle")}
        {field("birthday", "Birthday", "", "date")}
        {field("weight", "Weight", "e.g. 22 lb")}
      </div>
      {!compact && (
        <>
          {field("food", "Food & amounts", "e.g. 1 cup Purina Pro Plan, twice a day")}
          {field("microchip", "Microchip number", "e.g. 985112003456789")}
          {field("allergies", "Allergies", "e.g. Chicken, penicillin")}
          {field("conditions", "Medical conditions (as noted by your vet)", "e.g. Diabetes")}
          {field("medications_note", "Current medications", "e.g. Insulin 4u twice daily")}
          <div><label className="pl-label">Quirks & habits</label>
            <textarea data-testid="pet-quirks-input" rows={3} className="pl-input py-3" placeholder="e.g. Hides under the bed during storms. Will steal socks." value={f.quirks || ""} onChange={set("quirks")} /></div>
          <div className="grid grid-cols-2 gap-3">{field("vet_name", "Vet (if different)", "Dr. Patel")}{field("vet_phone", "Vet phone", "(555) 123-4567", "tel")}</div>
        </>
      )}
      <button data-testid="pet-save-btn" disabled={saving || !f.name} className="pl-btn-primary w-full">{saving ? "Saving..." : submitLabel}</button>
    </form>
  );
}
